import { useState } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";
import { User } from "@/types/user";

export interface CreateUserData {
  first_name: User["first_name"];
  last_name: User["last_name"];
  email: User["email"];
  password: string;
  confirm_password: string;
}

export interface CreateUserResponse {
  success: boolean;
  message: string;
  user: {
    id: User["id"];
    email: User["email"];
  };
}

export const useCreateUser = () => {
  const [data, setData] = useState<CreateUserResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const createUser = async (userData: CreateUserData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.post<CreateUserResponse>(
        "users/users/create/",
        userData,
      );

      setData(response.data);
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        setError(err.message);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, createUser };
};
